export abstract class ScrollHelper {

    public static scrollToFirst(idName?: string, className?: string, behavior: ScrollBehavior = 'smooth') {
        if (!idName && !className) {
            document.getElementsByTagName('body')[0].scrollIntoView({ block: 'start', behavior: behavior });
            return;
        }

        const form = document.getElementById(idName);
        const elements = form ? form.getElementsByClassName(className) : document.getElementsByClassName(className);

        if (!elements.length) {
            return;
        }

        elements[0].scrollIntoView({ block: 'end', behavior: behavior });
    }

    public static scrollToBottom(behavior: ScrollBehavior = 'smooth'): void {
        window.scrollTo({ behavior: behavior, top: document.body.scrollHeight });
    }
}
